import routesUtils from '@/utils/routes';
import ConfiguracaoParametros from '@/views/contratos-originacao/parametros/routes';
import ConfiguracaoPlantaFabril from '@/views/contratos-originacao/planta-fabril/routes';
import ConfiguracaoMaterial from '@/views/contratos-originacao/material/routes';
import ConfiguracaoEspecialista from '@/views/contratos-originacao/especialista/routes';

const constratosOriginacao = [
    {
        path: '/rastreabilidade/empresa',
        meta: {
            roles: ['ROLE_FEATURE_RASTREABILIDADE_EMPRESA']
        },
        component: () => import('@/views/DefaultRouterView'),
        children: [
            {
                path: '',
                name: 'RastreabilidadeEmpresa',
                meta: {
                    roles: ['ROLE_FEATURE_RASTREABILIDADE_EMPRESA']
                },
                component: () =>
                    import(
                        '@/views/contratos-originacao/EmpresaGestaoContratos'
                    )
            },
            {
                path: 'contratos-originacao/cadastrar',
                name: 'CadastrarContratoOriginacaoEmpresa',
                meta: {
                    roles: ['ROLE_FEATURE_RASTREABILIDADE_EMPRESA']
                },
                component: () =>
                    import(
                        '@/views/contratos-originacao/EmpresaInserirContrato'
                    )
            },
            {
                path: 'contratos-originacao/upload',
                name: 'UploadVerificacaoTerritorios',
                meta: {
                    roles: ['ROLE_FEATURE_RASTREABILIDADE_EMPRESA']
                },
                component: () =>
                    import(
                        '@/views/contratos-originacao/EmpresaUploadVerificacao'
                    )
            },
            {
                path: 'contratos-originacao/upload/historico-recebimentos',
                name: 'HistoricoRecebimentosEmpresa',
                meta: {
                    roles: ['ROLE_FEATURE_RASTREABILIDADE_EMPRESA']
                },
                component: () =>
                    import(
                        '@/views/contratos-originacao/EmpresaHistoricoRecebimentos'
                    )
            },
            {
                path: 'contratos-originacao/:id',
                name: 'VisualizarContratoOriginacaoEmpresa',
                meta: {
                    roles: ['ROLE_FEATURE_RASTREABILIDADE_EMPRESA']
                },
                component: () =>
                    import(
                        '@/views/contratos-originacao/EmpresaVisualizarContrato'
                    )
            },
            {
                path: 'contratos-originacao/paraguai/:id',
                name: 'VisualizarContratoOriginacaoEmpresaPY',
                meta: {
                    roles: ['ROLE_FEATURE_RASTREABILIDADE_EMPRESA']
                },
                component: () =>
                    import(
                        '@/views/contratos-originacao/EmpresaVisualizarContratoPY'
                    )
            },
            {
                path: 'contratos-originacao/argentina/:id',
                name: 'VisualizarContratoOriginacaoEmpresaAR',
                meta: {
                    roles: ['ROLE_FEATURE_RASTREABILIDADE_EMPRESA']
                },
                component: () =>
                    import(
                        '@/views/contratos-originacao/EmpresaVisualizarContratoAR'
                    )
            },
            {
                path: 'contratos-originacao/editar/:id',
                name: 'EditarContratoOriginacaoEmpresa',
                meta: {
                    roles: ['ROLE_FEATURE_RASTREABILIDADE_EMPRESA']
                },
                component: () =>
                    import('@/views/contratos-originacao/EmpresaEditarContrato')
            },
            {
                path: 'contratos-originacao/paraguai/editar/:id',
                name: 'EditarContratoOriginacaoEmpresaPY',
                meta: {
                    roles: ['ROLE_FEATURE_RASTREABILIDADE_EMPRESA']
                },
                component: () =>
                    import(
                        '@/views/contratos-originacao/EmpresaEditarContratoPY'
                    )
            },
            {
                path: 'contratos-originacao/argentina/editar/:id',
                name: 'EditarContratoOriginacaoEmpresaAR',
                meta: {
                    roles: ['ROLE_FEATURE_RASTREABILIDADE_EMPRESA']
                },
                component: () =>
                    import(
                        '@/views/contratos-originacao/EmpresaEditarContratoAR'
                    )
            },
            {
                path: 'dashboard',
                name: 'DashboardRastreabilidadeEmpresa',
                meta: {
                    roles: ['ROLE_FEATURE_RASTREABILIDADE_EMPRESA']
                },
                component: () =>
                    import(
                        '@/views/contratos-originacao/EmpresaDashboardContratos'
                    )
            },
            {
                path: 'dashboard-subempresa',
                name: 'DashboardRastreabilidadeSubEmpresa',
                meta: {
                    roles: ['ROLE_FEATURE_RASTREABILIDADE_EMPRESA']
                },
                component: () =>
                    import(
                        '@/views/contratos-originacao/SubEmpresaDashboardContratos'
                    )
            }
        ]
    },
    {
        path: '/rastreabilidade/subempresa',
        meta: {
            roles: ['ROLE_FEATURE_RASTREABILIDADE_SUB_EMPRESA']
        },
        component: () => import('@/views/DefaultRouterView'),
        children: [
            {
                path: '',
                name: 'RastreabilidadeSubEmpresa',
                meta: {
                    roles: ['ROLE_FEATURE_RASTREABILIDADE_SUB_EMPRESA']
                },
                component: () =>
                    import(
                        '@/views/contratos-originacao/SubEmpresaGestaoContratos'
                    )
            },
            {
                path: 'contrato/:numeroContrato',
                name: 'PreencherContratoOriginacao',
                meta: {
                    roles: ['ROLE_FEATURE_RASTREABILIDADE_SUB_EMPRESA']
                },
                component: () =>
                    import(
                        '@/views/contratos-originacao/SubEmpresaPreencherContrato'
                    )
            },
            {
                path: 'visualizar-processamento/:numeroContrato',
                name: 'VisualizarProcessamentoContratoOriginacao',
                meta: {
                    roles: ['ROLE_FEATURE_RASTREABILIDADE_SUB_EMPRESA']
                },
                component: () =>
                    import(
                        '@/views/contratos-originacao/SubEmpresaVisualizarProcessamentoContrato'
                    )
            }
        ]
    },
    {
        path: '/configuracao-rastreabilidade/',
        meta: {
            roles: ['ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE']
        },
        component: () => import('@/views/DefaultRouterView'),
        children: [
            ...ConfiguracaoParametros,
            ...ConfiguracaoPlantaFabril,
            ...ConfiguracaoEspecialista,
            {
                path: '',
                name: 'ConfiguracaoRastreabilidade',
                meta: {
                    roles: [
                        'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                        'ROLE_ADMINISTRATOR'
                    ]
                },
                beforeEnter: (to, from, next) => {
                    const usuarioLogado = JSON.parse(
                        sessionStorage.getItem('dadosUsuario')
                    );

                    routesUtils.userHasRequiredRoles(
                        usuarioLogado,
                        to.meta.roles
                    )
                        ? next()
                        : next('/');
                },
                component: () =>
                    import(
                        '@/views/contratos-originacao/ConfiguracaoRastreabilidade'
                    )
            },
            {
                path: '/gerentes-comerciais',
                name: 'ConfiguracaoGerentesComerciais',
                meta: {
                    roles: [
                        'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                        'ROLE_ADMINISTRATOR'
                    ]
                },
                beforeEnter: (to, from, next) => {
                    const usuarioLogado = JSON.parse(
                        sessionStorage.getItem('dadosUsuario')
                    );

                    routesUtils.userHasRequiredRoles(
                        usuarioLogado,
                        to.meta.roles
                    )
                        ? next()
                        : next('/');
                },
                component: () =>
                    import(
                        '@/views/contratos-originacao/gerente-comercial/ConfiguracaoGerentesComerciais.vue'
                    )
            },
            {
                path: '/gerentes-comerciais/cadastro',
                name: 'GerentesComerciaisCadastro',
                meta: {
                    roles: [
                        'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                        'ROLE_ADMINISTRATOR'
                    ]
                },
                beforeEnter: (to, from, next) => {
                    const usuarioLogado = JSON.parse(
                        sessionStorage.getItem('dadosUsuario')
                    );

                    routesUtils.userHasRequiredRoles(
                        usuarioLogado,
                        to.meta.roles
                    )
                        ? next()
                        : next('/');
                },
                component: () =>
                    import(
                        '@/views/contratos-originacao/gerente-comercial/FormularioGerenteComercial.vue'
                    )
            },
            {
                path: '/gerentes-comerciais/editar',
                name: 'GerentesComerciaisEdicao',
                props: true,
                meta: {
                    roles: [
                        'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                        'ROLE_ADMINISTRATOR'
                    ]
                },
                beforeEnter: (to, from, next) => {
                    const usuarioLogado = JSON.parse(
                        sessionStorage.getItem('dadosUsuario')
                    );

                    routesUtils.userHasRequiredRoles(
                        usuarioLogado,
                        to.meta.roles
                    )
                        ? next()
                        : next('/');
                },
                component: () =>
                    import(
                        '@/views/contratos-originacao/gerente-comercial/FormularioGerenteComercial.vue'
                    )
            },
            {
                path: '/gerentes-comerciais/detalhes',
                name: 'GerentesComerciaisDetalhes',
                props: true,
                meta: {
                    roles: [
                        'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                        'ROLE_ADMINISTRATOR'
                    ]
                },
                beforeEnter: (to, from, next) => {
                    const usuarioLogado = JSON.parse(
                        sessionStorage.getItem('dadosUsuario')
                    );

                    routesUtils.userHasRequiredRoles(
                        usuarioLogado,
                        to.meta.roles
                    )
                        ? next()
                        : next('/');
                },
                component: () =>
                    import(
                        '@/views/contratos-originacao/gerente-comercial/DetalhesGerenteComercial.vue'
                    )
            },
            {
                path: '/regionais',
                name: 'ConfiguracaoRegionais',
                meta: {
                    roles: [
                        'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                        'ROLE_ADMINISTRATOR'
                    ]
                },
                beforeEnter: (to, from, next) => {
                    const usuarioLogado = JSON.parse(
                        sessionStorage.getItem('dadosUsuario')
                    );

                    routesUtils.userHasRequiredRoles(
                        usuarioLogado,
                        to.meta.roles
                    )
                        ? next()
                        : next('/');
                },
                component: () =>
                    import(
                        '@/views/contratos-originacao/regional/Regionais.vue'
                    )
            },
            {
                path: '/regionais/cadastro',
                name: 'RegionalCadastro',
                meta: {
                    roles: [
                        'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                        'ROLE_ADMINISTRATOR'
                    ]
                },
                beforeEnter: (to, from, next) => {
                    const usuarioLogado = JSON.parse(
                        sessionStorage.getItem('dadosUsuario')
                    );

                    routesUtils.userHasRequiredRoles(
                        usuarioLogado,
                        to.meta.roles
                    )
                        ? next()
                        : next('/');
                },
                component: () =>
                    import(
                        '@/views/contratos-originacao/regional/FormularioRegional.vue'
                    )
            },
            {
                path: '/regional/editar',
                name: 'RegionalEdicao',
                props: true,
                meta: {
                    roles: [
                        'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                        'ROLE_ADMINISTRATOR'
                    ]
                },
                beforeEnter: (to, from, next) => {
                    const usuarioLogado = JSON.parse(
                        sessionStorage.getItem('dadosUsuario')
                    );

                    routesUtils.userHasRequiredRoles(
                        usuarioLogado,
                        to.meta.roles
                    )
                        ? next()
                        : next('/');
                },
                component: () =>
                    import(
                        '@/views/contratos-originacao/regional/FormularioRegional.vue'
                    )
            },
            {
                path: '/regional/detalhes',
                name: 'RegionalDetalhes',
                props: true,
                meta: {
                    roles: [
                        'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                        'ROLE_ADMINISTRATOR'
                    ]
                },
                beforeEnter: (to, from, next) => {
                    const usuarioLogado = JSON.parse(
                        sessionStorage.getItem('dadosUsuario')
                    );

                    routesUtils.userHasRequiredRoles(
                        usuarioLogado,
                        to.meta.roles
                    )
                        ? next()
                        : next('/');
                },
                component: () =>
                    import(
                        '@/views/contratos-originacao/regional/DetalhesRegional.vue'
                    )
            },
            {
                path: '/gerentes-regionais',
                name: 'GerentesRegionais',
                meta: {
                    roles: [
                        'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                        'ROLE_ADMINISTRATOR'
                    ]
                },
                beforeEnter: (to, from, next) => {
                    const usuarioLogado = JSON.parse(
                        sessionStorage.getItem('dadosUsuario')
                    );

                    routesUtils.userHasRequiredRoles(
                        usuarioLogado,
                        to.meta.roles
                    )
                        ? next()
                        : next('/');
                },
                component: () =>
                    import(
                        '@/views/contratos-originacao/gerentes-regionais/GerentesRegionais.vue'
                    )
            },
            {
                path: '/gerentes-regionais/cadastro',
                name: 'GerenteRegionalCadastro',
                meta: {
                    roles: [
                        'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                        'ROLE_ADMINISTRATOR'
                    ]
                },
                beforeEnter: (to, from, next) => {
                    const usuarioLogado = JSON.parse(
                        sessionStorage.getItem('dadosUsuario')
                    );

                    routesUtils.userHasRequiredRoles(
                        usuarioLogado,
                        to.meta.roles
                    )
                        ? next()
                        : next('/');
                },
                component: () =>
                    import(
                        '@/views/contratos-originacao/gerentes-regionais/FormularioGerenteRegional.vue'
                    )
            },
            {
                path: '/gerentes-regionais/editar',
                name: 'GerenteRegionalEdicao',
                props: true,
                meta: {
                    roles: [
                        'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                        'ROLE_ADMINISTRATOR'
                    ]
                },
                beforeEnter: (to, from, next) => {
                    const usuarioLogado = JSON.parse(
                        sessionStorage.getItem('dadosUsuario')
                    );

                    routesUtils.userHasRequiredRoles(
                        usuarioLogado,
                        to.meta.roles
                    )
                        ? next()
                        : next('/');
                },
                component: () =>
                    import(
                        '@/views/contratos-originacao/gerentes-regionais/FormularioGerenteRegional.vue'
                    )
            },
            {
                path: '/gerentes-regionais/detalhes',
                name: 'GerenteRegionalDetalhes',
                props: true,
                meta: {
                    roles: [
                        'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                        'ROLE_ADMINISTRATOR'
                    ]
                },
                beforeEnter: (to, from, next) => {
                    const usuarioLogado = JSON.parse(
                        sessionStorage.getItem('dadosUsuario')
                    );

                    routesUtils.userHasRequiredRoles(
                        usuarioLogado,
                        to.meta.roles
                    )
                        ? next()
                        : next('/');
                },
                component: () =>
                    import(
                        '@/views/contratos-originacao/gerentes-regionais/DetalhesGerenteRegional.vue'
                    )
            },
            {
                path: '/fornecedores',
                name: 'ConfiguracaoFornecedores',
                meta: {
                    roles: [
                        'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                        'ROLE_ADMINISTRATOR'
                    ]
                },
                beforeEnter: (to, from, next) => {
                    const usuarioLogado = JSON.parse(
                        sessionStorage.getItem('dadosUsuario')
                    );

                    routesUtils.userHasRequiredRoles(
                        usuarioLogado,
                        to.meta.roles
                    )
                        ? next()
                        : next('/');
                },
                component: () =>
                    import(
                        '@/views/contratos-originacao/fornecedores/ConfiguracaoFornecedores.vue'
                    )
            },
            {
                path: '/fornecedores/cadastro',
                name: 'CadastroFornecedor',
                meta: {
                    roles: [
                        'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                        'ROLE_ADMINISTRATOR'
                    ]
                },
                beforeEnter: (to, from, next) => {
                    const usuarioLogado = JSON.parse(
                        sessionStorage.getItem('dadosUsuario')
                    );

                    routesUtils.userHasRequiredRoles(
                        usuarioLogado,
                        to.meta.roles
                    )
                        ? next()
                        : next('/');
                },
                component: () =>
                    import(
                        '@/views/contratos-originacao/fornecedores/CadastrarFornecedor.vue'
                    )
            },
            {
                path: '/fornecedores/editar',
                name: 'EditarFornecedor',
                props: true,
                meta: {
                    roles: [
                        'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                        'ROLE_ADMINISTRATOR'
                    ]
                },
                beforeEnter: (to, from, next) => {
                    const usuarioLogado = JSON.parse(
                        sessionStorage.getItem('dadosUsuario')
                    );

                    routesUtils.userHasRequiredRoles(
                        usuarioLogado,
                        to.meta.roles
                    )
                        ? next()
                        : next('/');
                },
                component: () =>
                    import(
                        '@/views/contratos-originacao/fornecedores/EditarFornecedor.vue'
                    )
            },
            {
                path: '/fornecedores/detalhes',
                name: 'DetalhesFornecedor',
                props: true,
                meta: {
                    roles: [
                        'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                        'ROLE_ADMINISTRATOR'
                    ]
                },
                beforeEnter: (to, from, next) => {
                    const usuarioLogado = JSON.parse(
                        sessionStorage.getItem('dadosUsuario')
                    );

                    routesUtils.userHasRequiredRoles(
                        usuarioLogado,
                        to.meta.roles
                    )
                        ? next()
                        : next('/');
                },
                component: () =>
                    import(
                        '@/views/contratos-originacao/fornecedores/DetalhesFornecedor.vue'
                    )
            },
            {
                path: '/gerentes-territoriais',
                name: 'ConfiguracaoGerentesTerritoriais',
                meta: {
                    roles: [
                        'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                        'ROLE_ADMINISTRATOR'
                    ]
                },
                beforeEnter: (to, from, next) => {
                    const usuarioLogado = JSON.parse(
                        sessionStorage.getItem('dadosUsuario')
                    );

                    routesUtils.userHasRequiredRoles(
                        usuarioLogado,
                        to.meta.roles
                    )
                        ? next()
                        : next('/');
                },
                component: () =>
                    import(
                        '@/views/contratos-originacao/gerentes-territoriais/ConfiguracaoGerentesTerritoriais.vue'
                    )
            },
            {
                path: '/gerentes-territoriais/cadastro',
                name: 'CadastroGerenteTerritorial',
                meta: {
                    roles: [
                        'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                        'ROLE_ADMINISTRATOR'
                    ]
                },
                beforeEnter: (to, from, next) => {
                    const usuarioLogado = JSON.parse(
                        sessionStorage.getItem('dadosUsuario')
                    );

                    routesUtils.userHasRequiredRoles(
                        usuarioLogado,
                        to.meta.roles
                    )
                        ? next()
                        : next('/');
                },
                component: () =>
                    import(
                        '@/views/contratos-originacao/gerentes-territoriais/CadastrarGerenteTerritorial.vue'
                    )
            },
            {
                path: '/gerentes-territoriais/editar',
                name: 'EditarGerenteTerritorial',
                props: true,
                meta: {
                    roles: [
                        'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                        'ROLE_ADMINISTRATOR'
                    ]
                },
                beforeEnter: (to, from, next) => {
                    const usuarioLogado = JSON.parse(
                        sessionStorage.getItem('dadosUsuario')
                    );

                    routesUtils.userHasRequiredRoles(
                        usuarioLogado,
                        to.meta.roles
                    )
                        ? next()
                        : next('/');
                },
                component: () =>
                    import(
                        '@/views/contratos-originacao/gerentes-territoriais/EditarGerenteTerritorial.vue'
                    )
            },
            {
                path: '/gerentes-territoriais/detalhes',
                name: 'DetalhesGerenteTerritorial',
                props: true,
                meta: {
                    roles: [
                        'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                        'ROLE_ADMINISTRATOR'
                    ]
                },
                beforeEnter: (to, from, next) => {
                    const usuarioLogado = JSON.parse(
                        sessionStorage.getItem('dadosUsuario')
                    );

                    routesUtils.userHasRequiredRoles(
                        usuarioLogado,
                        to.meta.roles
                    )
                        ? next()
                        : next('/');
                },
                component: () =>
                    import(
                        '@/views/contratos-originacao/gerentes-territoriais/DetalhesGerenteTerritorial.vue'
                    )
            },
            {
                path: '/segmentos',
                name: 'ConfiguracaoSegmentos',
                meta: {
                    roles: [
                        'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                        'ROLE_ADMINISTRATOR'
                    ]
                },
                beforeEnter: (to, from, next) => {
                    const usuarioLogado = JSON.parse(
                        sessionStorage.getItem('dadosUsuario')
                    );

                    routesUtils.userHasRequiredRoles(
                        usuarioLogado,
                        to.meta.roles
                    )
                        ? next()
                        : next('/');
                },
                component: () =>
                    import('@/views/contratos-originacao/ConfiguracaoSegmentos')
            },
            {
                path: '/segmentos/cadastro',
                name: 'CadastroSegmento',
                meta: {
                    roles: [
                        'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                        'ROLE_ADMINISTRATOR'
                    ]
                },
                beforeEnter: (to, from, next) => {
                    const usuarioLogado = JSON.parse(
                        sessionStorage.getItem('dadosUsuario')
                    );

                    routesUtils.userHasRequiredRoles(
                        usuarioLogado,
                        to.meta.roles
                    )
                        ? next()
                        : next('/');
                },
                component: () =>
                    import('@/views/contratos-originacao/CadastrarSegmento')
            },
            ...ConfiguracaoMaterial
        ]
    }
];

export default constratosOriginacao;
